export default {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  BASE_URL_LOGGER: process.env.REACT_APP_BASE_URL_LOGGER,
  URL_SOCKET: process.env.REACT_APP_SOCKET,
  BASIC_SECURITY: process.env.REACT_APP_BASIC_SECURITY,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
};
